class SortBy extends HTMLElement {
  constructor() {
    super();
    this.sortBy = this.sortBy.bind(this);
  }

  sortBy() {
    this.inputs = this.querySelectorAll(".input-sort");

    if (!this.inputs.length) return;

    this.inputs.forEach((el) => {
      el.addEventListener("change", ({ target }) => {
        const { value } = target;

        const urlParams = new URLSearchParams(window.location.search);

        urlParams.set('sort_by', value);

        window.location.search = urlParams.toString();
      });
    });
  }

  connectedCallback() {
    this.sortBy();
  }
}

const init = () => {
  if (!customElements.get("sort-by")) {
    customElements.define("sort-by", SortBy);
  }
};

init();
